export type NormalizedFacetFilters = string[][];

export function normalizeFacetFilters(input: unknown): NormalizedFacetFilters {
  if (input == null) return [];
  if (!Array.isArray(input)) return [[String(input)]];
  if (input.length === 0) return [];

  const hasNestedGroups = input.some(Array.isArray);
  if (!hasNestedGroups) {
    return [input.map(value => String(value))];
  }

  return input.map(group => (Array.isArray(group) ? group.map(value => String(value)) : [String(group)]));
}
